import React from 'react';
import { PieChart, Pie, Legend, Cell, ResponsiveContainer } from 'recharts';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const data01 = [
  { name: 'Online', value: 85 },
  { name: 'Offline', value: 15 },
];

const COLORS = ['#02BC77', '#FF2366'];

const Bullet = ({ backgroundColor, size }) => {
  return (
    <div
      className='circle-bullet'
      style={{
        backgroundColor,
        width: size,
        height: size,
      }}
    ></div>
  );
};

const CustomizedLegend = (props) => {
  const { payload } = props;
  return (
    <div className='d-flex flex-column align-items-right'>
      <ul className='devices-dashboard-current-chart-legend'>
        {payload.map((entry, index) => (
          <li key={`item-${index}`}>
            <div className='devices-dashboard-current-chart-legend-bullet'>
              <Bullet backgroundColor={entry.payload.fill} size='10px' />
              <div className='ms-2'>{entry.value}</div>
            </div>
            <div className='gray-text ms-3'>({entry.payload.value})</div>
          </li>
        ))}
      </ul>
      <div className='d-flex justify-content-end devices-dashboard-current-chart-legend-info align-items-center'>
        <div className='red-text'>
          <ArrowUpwardIcon fontSize='small' />2 %{' '}
        </div>
        <div className='ms-2'>last mth</div>
      </div>
    </div>
  );
};

const CurrrentStatusChart = () => {
  return (
    <div style={{ width: '100%', height: 115 }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie data={data01} dataKey='value' cx={150} cy={60} innerRadius={0} outerRadius={100}>
            {data01.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Legend content={<CustomizedLegend />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CurrrentStatusChart;
